module.exports = __webpack_public_path__ + "img/Water.c0dfda4e.svg";